import { APP_STORES, AppStore } from "./storeLinks";

export type StorePlatform = "ios" | "android" | "other";

interface PlatformEnvironment {
  userAgent: string;
  maxTouchPoints: number;
}

/**
 * Which store this device installs from. iPadOS reports itself as a Mac, so a "Macintosh" with
 * more than one touch point counts as iOS.
 */
export function detectPlatform(env: PlatformEnvironment = navigator): StorePlatform {
  const ua = env.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/.test(ua)) return "ios";
  if (/Macintosh/.test(ua) && env.maxTouchPoints > 1) return "ios";
  return "other";
}

/** The stores to offer: the phone's own store only, both elsewhere. */
export function storesFor(platform: StorePlatform): readonly AppStore[] {
  if (platform === "ios") return APP_STORES.filter((store) => store.id === "app-store");
  if (platform === "android") return APP_STORES.filter((store) => store.id === "google-play");
  return APP_STORES;
}

/** A QR code only helps where another device scans it — never on the phone itself. */
export function showsQrCodes(platform: StorePlatform): boolean {
  return platform === "other";
}
